const COMBINING_MARKS_REGEX = /[\u0300-\u036f]/g;

export function normalizeForSearch(value: string): string {
  return value
    .toLowerCase()
    .normalize("NFD")
    .replace(COMBINING_MARKS_REGEX, "")
    .replace(/đ/g, "dj")
    .replace(/[čć]/g, "c")
    .replace(/š/g, "s")
    .replace(/ž/g, "z")
    .replace(/\s+/g, " ")
    .trim();
}

export function searchIncludes(haystack: string, needle: string): boolean {
  const normalizedNeedle = normalizeForSearch(needle);
  if (!normalizedNeedle) return true;
  return normalizeForSearch(haystack).includes(normalizedNeedle);
}
